export const FILTER_CONSTS = {
    GET_FILTERS: "GET_FILTERS",
    GET_FILTER_BY_ID: "GET_FILTER_BY_ID",
    CREATE_FILTER: "CREATE_FILTER",
    CREATE_FILTER_VALUES: "CREATE_FILTER_VALUES",
    UPDATE_FILTER_BY_ID: "UPDATE_FILTER_BY_ID",
    DELETE_FILTER_BY_ID: "DELETE_FILTER_BY_ID",
    DELETE_FILTER_VALUE_BY_ID: "DELETE_FILTER_VALUE_BY_ID",
};
